import React from "react";
import "./Footer.css";
import logo from "../../assets/logo.png";
import { FaPhone } from "react-icons/fa";

const Footer = () => {
  return (
    <>
      <section className="cta">
        <div>
          <h2>Ready to Start Your Project?</h2>
          <p>Contact us today and let's build something amazing together!</p>
        </div>

        <button
          className="cta-button"
          onClick={() => (window.location.href = "tel:7708534804")}
        >
          +91 7708534804 <FaPhone style={{ marginLeft: "8px" }} />
        </button>
      </section>
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-section fade-in">
            <h2>Zest Pack Technology</h2>
            <img src={logo} alt="Image is not Found" className="footer_logo" />
            <p>
              At Zest Pack Technology is focused on delivering value and results
              to customers. The success of our customers is equal to our
              success.{" "}
            </p>
          </div>

          <div className="footer-section slide-in-left">
            <h3>Quick Links</h3>
            <ul>
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/about">About</a>
              </li>
              <li>
                <a href="/services">Services</a>
              </li>
              <li>
                <a href="/contact">Contact</a>
              </li>
            </ul>
          </div>

          <div className="footer-section slide-in-right">
            <h3>Contact Us</h3>
            <p onClick={() => window.location.href = "mailto:zestpack24@gmail.com"} style={{cursor: 'pointer'}}>Email: zestpack24@gmail.com</p>

            <p onClick={() => (window.location.href = "tel:7708534804")} style={{cursor:'pointer'}}>Phone: +91 7708534804</p>
            <p>Location: 9/213C Ponnusamy Nagar, Balasamuthiram, Thottiyam, Trichy - 621203</p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2025 Zest Pack Technology. All Rights Reserved.</p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
